import d3 from 'd3';
import mori from 'mori';
import linechartConfig, {
  xTickFormat,
  yTickFormat,
  chartY,
	roundDown,
	roundUp,
	contentGenerator,
} from '../../config/linechart';
import template from './linechart.html';
import { pluck, modZip } from '../../util/util';

export default function() {
  return {
    scope: {},
    templateUrl: template,
    templateNamespace: 'svg',
    controller: Controller,
    controllerAs: 'vm',
    bindToController: {
      immutableData: '=',
    },
  };
}

Controller.$inject = ['$scope', '$document', '$filter'];
function Controller($scope, $document, $filter) {
  this.options = linechartConfig;
  this.legend = {};
  this.$document = $document;
  this.$filter = $filter;

  $scope.$watch(function(newval) {
    return mori.hash(newval.vm.immutableData);
  }, this.dataUpdated.bind(this));
}

Controller.prototype.dataUpdated = function() {
  this.data = mori.toJs(this.immutableData);

  if (this.data.length) {
    this.count = this.data.length;

    this.options = this.optionsFormatter();

    // Show all series for legend.
    // Filter for entirely empty series for chart
    this.processedChartLegendData = this.setGraphColorShape(this.data);
    this.processedGraphData = this.processedChartLegendData
      .filter((series) => series.values.filter((d) => d.y).length);
  }
};

/**
 * Used to format the options with column definition
 */
Controller.prototype.optionsFormatter = function() {
  const options = angular.copy(this.options);
  options.chart.y = chartY;

  options.chart.forceY = [
    0,
    roundDown(d3.min(this.data, (x) => {
      return d3.min(x.values, (value) => value.y);
    })),
    roundUp(d3.max(this.data, (x) => {
      return d3.max(x.values, (value) => value.y);
    })),
  ];

  // Build unique array of all chart values
  const allValues = this.data.reduce(
    (acc, curr) =>
      acc.concat(curr.values.reduce(
        (acc1, curr1) =>
          acc1.concat(curr1.y),
        [])
      ),
    []).filter((x) => x !== null);
  const unique = allValues.reduce(
    (acc, curr) => acc.indexOf(curr) > -1 ? acc : acc.concat(curr),
  []);

  options.chart.yAxis.ticks = unique.length - 1 < 10 ? unique.length - 1 : 10;
  options.chart.yAxis.tickFormat = yTickFormat.bind(this);
  options.chart.xAxis.tickFormat = xTickFormat.bind(this);
  options.chart.tooltip.contentGenerator = contentGenerator.bind(this);
  options.chart.margin.left = this.yAxisWidth(
    this.$filter('filterSwitch')(
      options.chart.forceY[1], this.data[0].selectedHeader
    )
  );

  return options;
};

Controller.prototype.setGraphColorShape = function(graphData) {
  const graphColors = [
    '#de5a02', '#f5cd34', '#2a91c2', '#63984f', '#6d3e8d',
    '#f27d00', '#99ae35', '#9d2d91', '#cf9c5b', '#009a9c',
    '#a64312', '#1e4784', '#62b36e', '#f09800', '#cc4e8f',
    '#75521c', '#bf1b00', '#514b9c', '#cbcd00', '#5e9cdb',
  ];

  const graphShapes = [
    'circle', 'square', 'triangle-down', 'diamond', 'triangle-up',
  ];

  const stateColor = modZip(
    pluck(graphData, 'state'),
    graphColors
  );

  const characteristicShape = modZip(
    pluck(graphData, 'characteristic'),
    graphShapes
  );

  return graphData.map((d) => {
    return angular.extend({}, d, {
      color: stateColor[d.state],
      shape: characteristicShape[d.characteristic],
      values: d.values.map((value) => angular.extend({}, value, {
        shape: characteristicShape[d.characteristic],
      })),
    });
  });
};

Controller.prototype.yAxisWidth = function(text) {
  const font = 'normal 12px Arial';
  // re-use canvas object for better performance
  const canvas = this.yAxisWidth.canvas
    || (this.yAxisWidth.canvas = this.$document[0].createElement(`canvas`));
  const context = canvas.getContext(`2d`);
  context.font = font;
  const metrics = context.measureText(text);
  return (metrics.width > 25) ? 50 + (metrics.width / 2) : 50;
};



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/linechart/linechart.js
 **/